import React, { useEffect, useState } from 'react';
import { useMemo } from 'react';

import BandButton from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/BandButton';
import CandidatesTable from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/CandidatesTable';
import DetailsTable from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/CandidatesTable/DetailsTable';
import Header from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/Header';
import SearchInput from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/SearchInput';
import UploadFileCandidatesBtn from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/UploadFileCandidatesBtn';

import styles from './styles.module.scss';
import { defaultProps, propTypes } from './types';
import useCandidatesTable from './useCandidatesTable';
import useDetailsTable from './useDetailsTable';
import useUploadFile from './useUploadFile';
import { Tabs, Tab, Box } from '@mui/material';
import PropTypes from 'prop-types';
import UploadPointsSection from '../UploadPointsSection';


const Candidates = (props) => {
  const { setLoading, loading, handleToast, title } = props;

  const [currentHistoryId, setCurrentHistoryId] = useState(undefined);
  const [searchText, setSearchText] = useState('');
  const showDetails = useMemo(() => !!currentHistoryId, [currentHistoryId]);
  const newCustumers = true;
  const { list, isLoading, sortByKey, sortDescStates, getHistory, filteredList } = useCandidatesTable({
    newCustumers,
    searchText,
  });

  const {
    list: listDetails,
    isLoading: isLoadingDetails,
    sortByKey: sortByKeyDetails,
    sortDescStates: sortDescStatesDetails,
  } = useDetailsTable(currentHistoryId);

  const { submitFile } = useUploadFile({ newCustumers, handleToast, setLoading, refreshData: getHistory });

  const titleBand = newCustumers ? 'Candidatos para firma de programas de mercado' : 'Candidatos para upgrade a Club B MAX';

  const handleShowDetail = (historyId) => {
    setCurrentHistoryId(historyId);
  };

  useEffect(() => {
    if (title && !!currentHistoryId) setCurrentHistoryId(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={styles.container}>
      <Header
        title="Candidatos"
        userName="User Name"
        onClickBack={() => setCurrentHistoryId(undefined)}
        back={showDetails}
      />

      <div className={styles.body}>
        <div className={styles.body__padding}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Carga Candidatos/Puntos" {...a11yProps(0)} />
                <Tab label="Historial Puntos" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <section>
              <UploadFileCandidatesBtn hide={showDetails} submitFile={submitFile} />
            </section>

            <BandButton title={titleBand} color="yellow" colorIcon="yellow" />

            <CandidatesTable
              onClickRow={({ id }) => handleShowDetail(id)}
              setLoading={setLoading}
              loading={loading}
              hide={showDetails}
              list={filteredList || list}
              isLoading={isLoading}
              sortByKey={sortByKey}
              sortDescStates={sortDescStates}
            />

            <DetailsTable
              setLoading={setLoading}
              loading={loading}
              hide={!showDetails}
              list={listDetails}
              isLoading={isLoadingDetails}
              sortByKey={sortByKeyDetails}
              sortDescStates={sortDescStatesDetails}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <UploadPointsSection />
          </CustomTabPanel>
        </div>
      </div>
    </div>
  );
};

Candidates.propTypes = propTypes;
Candidates.defaultProps = defaultProps;

export default Candidates;
